import { Amount, DataRow, Date, Text } from '../../components'
import { B2CPaymentsRequest } from '../../@types/b2c.types.ts'
import { B2CStateRenderer } from '../b2c/components/b2c-state-renderer.tsx'

export const MAIN_INFO_LABELS: Array<DataRow<B2CPaymentsRequest>> = [
  { key: 'transferId', label: 'Номер операции', renderer: Text },
  { key: 'trxId', label: 'ID перевода в СБП', renderer: Text },
  { key: 'updateTime', label: 'Дата, время', renderer: Date },
  { key: 'reference', label: '№ заявки B2C', renderer: Text },
  { key: 'type', label: 'Тип операции', renderer: Text },
  { key: 'state', label: 'Статус', renderer: B2CStateRenderer },
  { key: 'statusComment', label: 'Комментарии к статусу перевода', renderer: Text },
]

export const RCV_INFO_LABELS: Array<DataRow<B2CPaymentsRequest>> = [
  { key: 'recPhone', label: 'Номер телефона получателя', renderer: Text },
  { key: 'fioSetByClient', label: 'Ф.И.О. указанное при переводе', renderer: Text },
  { key: 'recPam', label: 'Ф.И.О.  привязанное к номеру телефона в СБП', renderer: Text },
  { key: 'rcvBankNameRus', label: 'Банк получателя', renderer: Text },
  { key: 'remitInfo', label: 'Назначение перевода', renderer: Text },
]

export const MONEY_INFO_LABELS: Array<DataRow<B2CPaymentsRequest>> = [
  { key: 'accountNumber', label: 'Счет списания', renderer: Text },
  { key: 'amount', label: 'Сумма перевода', renderer: Amount },
  { key: 'commissionMerchant', label: 'Комиссия банка', renderer: Amount },
  { key: 'writeOffAmount', label: 'Сумма списания со счета', renderer: Amount },
]
